module.exports = "/_next/static/images/404-pagina-21fd094c3b9d0cd1d88311c4448f7bc3.jpg";